import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { sideBarLinks } from "../utils/constants";
import { reactIcons } from "./../utils/icons";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import Loader from "./loaders/Loader";
import * as api from "../redux/api";
const Sidebar = ({ setIsOpen }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  // const handleLogOut = async () => {
  //   if (isLoading) return;
  //   setIsLoading(true);
  //   try {
  //     const res = await api.logout();
  //     const { data, status } = res;
  //     if (status) {
  //       toast.success("Logged Out Successfully");
  //       Cookies.remove("__admin__authToken");
  //       Cookies.remove("undefinedaccessToken");
  //       Cookies.remove("test__users__isLoggedIn");
  //       Cookies.remove("user_access_token");
  //       Cookies.remove("__user__authToken");
  //       navigate("/");
  //     } else {
  //       toast.error(data.message);
  //       Cookies.remove("accessToken");
  //       Cookies.remove("testnetaccessToken");
  //       navigate("/");
  //     }
  //   } catch (err) {
  //     toast.error(err.message);
  //     Cookies.remove("accessToken");
  //     Cookies.remove("testnetaccessToken");
  //     navigate("/");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const handleLogOut = async () => {
    if (isLoading) return;
    setIsLoading(true);

    const cookieKeys = [
      "__admin__authToken",
      "__user__authToken",
      "undefinedaccessToken",
      "test__users__isLoggedIn",
      "user_access_token",
      "accessToken",
      "testnetaccessToken"
    ];

    try {
      const res = await api.logout();
      const { status, data } = res;

      if (status) {
        toast.success("Logged Out Successfully");
      } else {
        toast.error(data.message || "Logout failed");
      }
    } catch (err) {
      toast.error(err.message || "An error occurred");
    } finally {
      // Remove everything regardless of API result
      cookieKeys.forEach((key) => Cookies.remove(key, { path: "/" }));
      navigate("/");
      setIsLoading(false);
    }
  };

  return (
    <div className="h-screen flex flex-col justify-between   shadow-md shadow-black/10  overflow-auto w-full py-8">
      <div className="flex items-center gap-2 justify-between pr-1">
        <div
          className="cursor-pointer px-2"
          onClick={() => navigate("/dashboard")}
        >
          <img src="/images/logo/logo.png" alt="logo" className="w-[120px]" />
        </div>
        <button
          onClick={() => setIsOpen(true)}
          className="w-10 h-10 flex-center bg-primary-100 text-white  rounded-full text-3xl"
        >
          {reactIcons.arrowleft}
        </button>
      </div>

      <div className="flex flex-col  gap-1  mt-8 xxl:mt-12 flex-1">
        {sideBarLinks.map((item, index) => (
          <div key={index}>
            {item.child ? (
              <div
                onClick={() =>
                  setOpenDropdown((prev) =>
                    prev === item.path ? null : item.path
                  )
                }
                className="relative font-semibold py-3 w-full px-4 flex justify-between items-center cursor-pointer duration-100 text-black hover:bg-yellow-dark"
              >
                <div className="flex gap-4 items-center">
                  <span className="text-xl">{item.icon}</span>
                  <span className="text-[14px] xl:text-[16px] select-none">
                    {item.title}
                  </span>
                </div>
                <span className="text-[25px]">
                  {openDropdown === item.path
                    ? reactIcons.arrowDown
                    : reactIcons.arrowUp}
                </span>
              </div>
            ) : (
              <NavLink
                to={item.path}
                onClick={() => setOpenDropdown(null)}
                end
                className={({ isActive }) =>
                  `relative font-semibold py-3 w-full px-4 flex gap-4 items-center cursor-pointer duration-100 ${
                    isActive
                      ? "bg-yellow-dark text-black"
                      : "text-black hover:bg-yellow-dark hover:text-black"
                  }`
                }
              >
                <span className="text-xl">{item.icon}</span>
                <span className="text-[14px] xl:text-[16px] select-none">
                  {item.title}
                </span>
              </NavLink>
            )}

            {item.child && openDropdown === item.path && (
              <div className="ml-6">
                {item.child.map((childItem, childIndex) => (
                  <NavLink
                    key={childIndex}
                    to={childItem.path}
                    end
                    className={({ isActive }) =>
                      `relative font-semibold py-3 w-full px-4 flex gap-2 items-center cursor-pointer duration-100 ${
                        isActive
                          ? " bg-yellow-dark text-black"
                          : "text-black hover:bg-yellow-dark hover:text-black"
                      }`
                    }
                  >
                    <span className="text-xl">{childItem.icon}</span>
                    <span className="text-[14px] xl:text-[16px] select-none">
                      {childItem.title}
                    </span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div>
        <div
          onClick={handleLogOut}
          className="relative font-semibold text-black py-3  w-full px-4  flex gap-4 items-center cursor-pointer duration-100 hover:bg-red-"
        >
          <span className="text-xl ">{!isLoading && reactIcons.logout}</span>{" "}
          <span className="text-[14px] xl:text-[16px] select-none">
            {isLoading ? <Loader /> : "Logout"}{" "}
          </span>{" "}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
